import React from "react"
import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../render/table/table-cell";
import UserIcon from "../../../../../gd-ui/icon/user/user";
import {ADD_USER} from "../../user";
import {FieldType} from "../../../../field-type";
import {LifecycleAction} from "../../../../../gd/const/lifecycle";
import {isBulkSelection} from "../../../../../gd/right-click-menu";

// const debug = "FieldUser_TableCell"
const debug = false


export default class FieldUser_TableCell extends React.Component<FieldTableCellProps, FieldTableCellState> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered: false,
            showPopover: false
        }
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    get canEdit() {
        if (this.props.manager.isReadOnly) return false
        if (!this.props.field.canEdit(this.props.listItem.item)) return false

        return true
    }

    onDelete = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        this.onValueChange(null)
    }

    onValueChange(value:any, hidePopover:boolean=true) {

        hidePopover && this.hidePopover()

        // if field has tableCellOnValueChange - use it !!!
        if (this.props.field.fieldParams.tableCellOnValueChange) {
            this.props.field.fieldParams.tableCellOnValueChange(this.props.listItem, value, this.props.manager)
            return
        }

        // Otherwise default = custom field

        this.props.listItem.item.setCustomFieldValue(this.props.field.fieldId, value)
        this.props.listItem.item.save()

        this.props.listItem._updateLastUpdateTime() // otherwise it wont re-render
        this.props.manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])

        return
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return

        // Editable check
        if (!this.canEdit) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    onOptionClick = (option:Option, e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        this.onValueChange(option.value)
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderHovered() {


        const field = this.props.field

        //this.props.column.id,
        const classes = Classes("cell-flex ui5-txt-less-important-small",  {
            'is-hovered'        : this.state.isHovered
        })

        const style : style = getTableCellStyle(this.props)

        const value = _.get(this.props.listItem.item, this.props.field.fieldId, null)

        const iconOnly:boolean = style.width<=80

        let result

        if (value) {
            result = this.renderValue(style.width)
        } else {
            result = <div className="txt-truncate">Select a user</div>
        }

        return (
            <React.Fragment>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                    <div className="ui5-field-editable is-hovered size-small w-100-percent h-100-percent" onClick={this.onClick}>

                        {result}

                        {!iconOnly &&
                            <div className="buttons flex-no-shrink">
                                {this.props.field.noValueOption && !!value &&
                                    <div className="btn-reset" onClick={this.onDelete}/>}
                                <div className="btn-arrow"/>
                            </div>
                        }

                    </div>

                    {this.state.showPopover &&
                        <field.components.PopoverMenu parent={this} field={this.props.field} model={this.props.listItem.item} />
                    }
                </div>
            </React.Fragment>
        )
    }

    renderValue(width: number) {

        const iconOnly:boolean = width<=80

        const value = _.get(this.props.listItem.item, this.props.field.fieldId, null)


        if (!value) {

            if (iconOnly) {
                return <div></div>
            }

            return (
                <div>Select a user</div>
            )
        }

        const user = gd.session.users.get(value)!

        if (iconOnly) {
            return (
                <div className={Classes("flex-row-center-center", "w-100-percent")}>
                    <UserIcon className="" userId={user.id} size="22"/>
                </div>
            )
        }

        return (
            <div className={Classes("flex-row-left-center", "w-100-percent")}>
                <UserIcon className="m-r-5" userId={user.id} size="22"/>
                <div className="max-w-100-percent txt-truncate">{user?.name}</div>
            </div>
        )
    }

    renderNotHovered() {
        const classes = Classes("cell-flex ui5-field-editable size-small ui5-txt-less-important-small")

        const userId = _.get(this.props.listItem.item, this.props.field.fieldId, null)
        const user = userId ? gd.session.users.get(userId) : null

        const style : style = getTableCellStyle(this.props)

        return (
            <React.Fragment>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>

                    {user && this.renderValue(style.width)}

                </div>
            </React.Fragment>
        )
    }

    render() {
        // debug && console.log(debug, "render()", this.props)
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()
    }
}



